import { createFileRoute } from "@tanstack/react-router";
import { guardEmployeeSurface } from "./-employee-surfaces";
import Page from "@/app/employee/[id]/online-courses/page";

export const Route = createFileRoute("/employee/$id/online-courses")({
  beforeLoad: ({ params }) => guardEmployeeSurface("online-courses", params.id),
  component: Page,
});
